import {SellerError} from './SellerError.js'

export class GenericSellerError extends SellerError {
  constructor(data) {
    super(data)
    this._errors = data.errors
    this._message = data.message
    this._error = data.error
    this._status = data.status
  }

  hasErrors() {
    return Boolean(this._errors.length)
  }

  getErrors() {
    return this._errors
  }
}
